import { useEffect } from 'react';
import { Banner, FlexContainer, Sizes, Spinner, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import CustomTransition from 'Components/CustomTransition';
import Arrow from 'Components/icons/Arrow';
import { routes } from 'Constants/routes';
import { openUrlInNewNavigator } from 'Utils/links';
import { WHATSAPP_DELETE_ACCOUNT } from 'Constants/whatsappLinks';
import { AccountDeleteProp } from '../AccountPrivacy/components/AccountDelete/types';
import { useFetchGetDeleteUser } from '../AccountPrivacy/hooks';
import EmbedForm from './components/EmbedForm';
import * as Styled from './styles';

const AccountDeleteForm = ({ setScreen, setSubContent }: AccountDeleteProp): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const { mutate, isLoading, data } = useFetchGetDeleteUser();

  useEffect(() => {
    mutate({});
  }, []);

  const userCantDelete = !data?.isDeleteAllowed;
  return (
    <CustomTransition start>
      <Styled.BackButton
        onClick={() => {
          history.replace(routes.ACCOUNT_DELETE_INFO);
          setScreen(2);
        }}
      >
        <Arrow />
        {t('common:BackButton')}
      </Styled.BackButton>
      {isLoading ? (
        <FlexContainer fullWidth fullHeight justify="center" align="center">
          <Spinner size="M" justify="center" align="center" />
        </FlexContainer>
      ) : userCantDelete ? (
        <Styled.FormContainer direction="column" fullWidth>
          <Banner
            id="delete-account-banner"
            label={t('Delete.account.form.banner.title')}
            mode="warning"
            hasIcon={false}
            position="vertically"
            buttonLabel={t('Delete.account.form.banner.button')}
            description={t('Delete.account.form.description')}
            titleSize={Sizes.XS}
            size={Sizes.M}
            onClick={() => openUrlInNewNavigator(WHATSAPP_DELETE_ACCOUNT)}
            layout="embed"
          />
        </Styled.FormContainer>
      ) : (
        <Styled.FormContainer direction="column" align="center" fullWidth>
          <Text align="center" type="fds_heading_bold_H5" color="dark_500">
            {t('Delete.account.form.title')}
          </Text>
          <EmbedForm setScreen={setScreen} setSubContent={setSubContent} />
        </Styled.FormContainer>
      )}
    </CustomTransition>
  );
};

export default AccountDeleteForm;
